/** Kopiert Text. `navigator.clipboard` gibt es nur über https oder localhost; im Test übers WLAN
 * (http://192.168…) greift deshalb der Umweg über ein verstecktes Textfeld. */
export async function kopiereText(text: string): Promise<boolean> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // weiter mit dem Umweg
    }
  }
  // Ein offener Dialog macht alles außerhalb unbedienbar, das Feld muss also in ihn hinein.
  const eltern = document.querySelector("dialog[open]") ?? document.body;
  const feld = document.createElement("textarea");
  feld.value = text;
  feld.setAttribute("readonly", "");
  feld.style.cssText = "position:fixed;top:0;left:0;opacity:0;font-size:16px";
  eltern.appendChild(feld);
  feld.focus();
  feld.select();
  feld.setSelectionRange(0, text.length);
  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    feld.remove();
  }
}

/** Beim Testen zeigt der Link auf localhost und würde am Handy ins Leere laufen: dann die Adresse
 * nehmen, unter der die Seite gerade geöffnet ist. Mit echter Domain ändert sich nichts. */
export function linkFuerDieseAdresse(link: string): string {
  try {
    const url = new URL(link);
    const lokal = ["localhost", "127.0.0.1"];
    if (lokal.includes(url.hostname) && !lokal.includes(window.location.hostname)) {
      return window.location.origin + url.pathname + url.search + url.hash;
    }
  } catch {
    // kein gültiger Link: unverändert lassen
  }
  return link;
}
